import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

const LOCALSTRKEY = 'LIVE_ROOM_CUSTOM_INFO';

export interface CustomInfoJson {
  reloadTime: number;
  msgType: string;
  msgItem: any;
}

const localGameInfo = LocalStore.getValue<CustomInfoJson>(LOCALSTRKEY) || {};

export const customInfo: CustomInfoJson = {
  reloadTime: 0,
  msgType: '',
  msgItem: undefined,
  ...localGameInfo
};

export const setCustomInfo: (payload: CustomInfoJson) => IAction<CustomInfoJson> = (payload: CustomInfoJson) => ({
  type: 'setCustomInfo',
  payload
});

const customInfoReducer: Reducer<CustomInfoJson, IAction<any>> = (state = customInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setCustomInfo':
      LocalStore.setValue(LOCALSTRKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default customInfoReducer;
